// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import TerceraCheckBoxButtonTemplate from '@front/templates/TerceraCheckBoxButtonTemplate.html';
import { TerceraCheckBox } from './TerceraCheckBox';
export class TerceraCheckBoxButton extends TerceraCheckBox {
    constructor() {
        super();
    }
}
TerceraCheckBox.extendWith(TerceraCheckBoxButton, {
    template: TerceraCheckBoxButtonTemplate,
    data: function () {
        return {
            checked: false, // checked или нет
            isSL: false,
            text: ''
        };
    }
});
